
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:550px;">
    <form #orderForm="ngForm">
      <div class="modal-header">
        <h4 class="modal-title">Select a K2 Site name</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <list-controls [showLimit]="false" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="k2SitesFiltered.length" (onChange)="onListControlsChange($event)"></list-controls>
        <table class="table table-striped">
          <thead>
            <tr>
              <th style="min-width:400px;">Site</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let site of k2SitesToShow">
              <td>{{ site.name }}</td>
              <td>
                <button class="btn btn-primary btn-sm" type="button" (click)="selectSite(site.id)">Select</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>